"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupersMenu = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const findGroupByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByKey"));
const findGroupByType_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByType"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const TimeInterval_1 = __importStar(require("@opsbase/lib-time/TimeInterval"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const ChevronLeftIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronLeftIcon"));
const GrouperIcon_1 = __importDefault(require("@opsbase/web-icons/icons/GrouperIcon"));
const HelpIcon_1 = __importDefault(require("@opsbase/web-icons/icons/HelpIcon"));
const RepeatRoundedIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RepeatRoundedIcon"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const NonModalPopover_1 = __importDefault(require("@opsbase/web-ui/NonModalPopover"));
const Switch_1 = __importDefault(require("@opsbase/web-ui/Switch"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importStar(require("react"));
function GroupersMenu({ groupableSelector, }) {
    const dt = (0, useDataTree_1.default)();
    const { groupBys, type, hideEmptyGroups } = (0, useView_1.default)(dt.viewId);
    const [showMainMenu, setShowMainMenu] = (0, react_1.useState)(false);
    const [dateGroupMenuState, setDateGroupMenuState] = (0, react_1.useState)();
    const buttonRef = (0, react_1.useRef)();
    const { addGroupBy, removeGroupBy, setGroupBys, setHideEmptyGroups } = (0, useViewActions_1.default)(dt.viewId);
    const { groupables } = MetaModelRegistry_1.default[type];
    const availableGroupables = (0, react_1.useMemo)(() => {
        const available = groupables.filter(f => !f.hidden);
        if (groupableSelector) {
            return groupableSelector(available);
        }
        return available;
    }, [groupableSelector, groupables]);
    const hasGroupBy = groupBys.length > 0;
    const hasBigGroupBy = (0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.RELATED_MODEL) ||
        (0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.STRING) ||
        (0, findGroupByType_1.default)(groupBys, BasicFieldType_1.default.DATE);
    const canHideEmptyGroups = hasGroupBy && !hasBigGroupBy;
    const canSwitchGroups = !hasBigGroupBy && groupBys.length > 1;
    const handleClickButton = (0, react_1.useCallback)(() => {
        setShowMainMenu(true);
    }, []);
    const handleCloseDateGroupMenu = (0, react_1.useCallback)(() => {
        setDateGroupMenuState(undefined);
        setShowMainMenu(false);
    }, []);
    const handleCloseMainMenu = (0, react_1.useCallback)(() => {
        if (dateGroupMenuState)
            return;
        handleCloseDateGroupMenu();
        setShowMainMenu(false);
    }, [handleCloseDateGroupMenu, dateGroupMenuState]);
    const handleToggleQueryField = (0, useCallforward_1.default)((queryField) => () => {
        if ((0, findGroupByKey_1.default)(groupBys, queryField.key)) {
            removeGroupBy({ queryFieldKey: queryField.key });
        }
        else {
            addGroupBy({ queryFieldKey: queryField.key });
        }
    }, [groupBys, addGroupBy, removeGroupBy]);
    const handleToggleDateGrouper = (0, useCallforward_1.default)(o => () => {
        const { groupBy } = dateGroupMenuState;
        const existingGroupBy = (0, findGroupByKey_1.default)(groupBys, groupBy.queryFieldKey);
        if (existingGroupBy)
            removeGroupBy(existingGroupBy);
        if (!existingGroupBy || existingGroupBy.timeInterval != o) {
            addGroupBy({
                queryFieldKey: groupBy.queryFieldKey,
                timeInterval: o,
            });
        }
    }, [addGroupBy, dateGroupMenuState, groupBys, removeGroupBy]);
    const handleSwitchGroups = (0, react_1.useCallback)(() => {
        setGroupBys([...groupBys].reverse());
    }, [setGroupBys, groupBys]);
    const handleHideEmptyGroups = (0, react_1.useCallback)(() => {
        setHideEmptyGroups(!hideEmptyGroups);
    }, [setHideEmptyGroups, hideEmptyGroups]);
    const handleDateGrouper = (0, useCallforward_1.default)(queryField => e => {
        setDateGroupMenuState({
            groupBy: { queryFieldKey: queryField.key },
            el: e.currentTarget,
        });
    }, []);
    if (!open) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        availableGroupables.length > 0 && (react_1.default.createElement(Button_1.default, { ref: buttonRef, style: { minHeight: 42 }, icon: react_1.default.createElement(GrouperIcon_1.default, null), color: hasGroupBy ? lib_palette_1.default.secondary : lib_palette_1.default.BlackCoral, background: true, onClick: handleClickButton }, hasGroupBy
            ? groupBys
                .map(g => {
                var _a;
                return (0, getFromStringOrFunction_1.getFromStringOrFunction)((_a = availableGroupables.find(ag => ag.key === g.queryFieldKey)) === null || _a === void 0 ? void 0 : _a.label);
            })
                .join(' + ')
            : lib_i18n_1.default.t('group-by'))),
        react_1.default.createElement(NonModalPopover_1.default, { open: !!showMainMenu, anchorEl: buttonRef.current, onClose: handleCloseMainMenu, placement: "bottom-end" },
            react_1.default.createElement("div", { style: { minWidth: 200 } }, availableGroupables.map(qf => {
                const isSelected = !!(0, findGroupByKey_1.default)(groupBys, qf.key);
                const isBigGroupable = qf.fieldType === BasicFieldType_1.default.RELATED_MODEL ||
                    qf.fieldType === BasicFieldType_1.default.STRING;
                const isDateGroupable = qf.fieldType === BasicFieldType_1.default.DATE;
                // We are only allowed to group by one ENTITY group at a time
                // This is a scalability optimization ... Group by PLACE + TEAM
                // for example, is just too much
                const isDisabled = !isSelected && ((hasGroupBy && isBigGroupable) || groupBys.length >= 2);
                const tip = isDisabled && isBigGroupable && hasBigGroupBy
                    ? lib_i18n_1.default.t('only-one-biggroupby')
                    : isDisabled && isBigGroupable
                        ? lib_i18n_1.default.t('biggroupby-must-come-first')
                        : undefined;
                return (react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true, key: qf.key },
                    react_1.default.createElement(Pane_1.default, { grow: true },
                        !!isDateGroupable && (react_1.default.createElement(MenuItem_1.default, { disabled: isDisabled, onClick: handleDateGrouper(qf), label: (0, getFromStringOrFunction_1.getFromStringOrFunction)(qf.label), icon: react_1.default.createElement(ChevronLeftIcon_1.default, { size: 20 }) })),
                        !isDateGroupable && (react_1.default.createElement(MenuItem_1.default, { disabled: isDisabled, onClick: handleToggleQueryField(qf), label: (0, getFromStringOrFunction_1.getFromStringOrFunction)(qf.label), icon: react_1.default.createElement(Switch_1.default, { tiny: true, disabled: isDisabled, onChange: handleToggleQueryField(qf), checked: isSelected, color: lib_palette_1.default.secondary }) }))),
                    !!tip && (react_1.default.createElement(Pane_1.default, { shrink: true, padding: true },
                        react_1.default.createElement(Tooltip_1.default, { arrow: true, transparent: false, placement: 'bottom', tip: react_1.default.createElement("div", { style: { padding: 5 } }, tip) },
                            react_1.default.createElement(HelpIcon_1.default, { size: 15, color: lib_palette_1.default.LavendarGrey }))))));
            })),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement("div", null,
                canHideEmptyGroups && (react_1.default.createElement(MenuItem_1.default, { label: lib_i18n_1.default.t('hide-empty-groups'), onClick: handleHideEmptyGroups, icon: react_1.default.createElement(Switch_1.default, { tiny: true, disabled: !canHideEmptyGroups, onChange: handleHideEmptyGroups, checked: hideEmptyGroups, color: lib_palette_1.default.secondary }) })),
                canSwitchGroups && (react_1.default.createElement(MenuItem_1.default, { onClick: handleSwitchGroups, label: lib_i18n_1.default.t('switch-groups'), icon: react_1.default.createElement(RepeatRoundedIcon_1.default, { size: 22, color: lib_palette_1.default.secondary }) })))),
        !!(dateGroupMenuState === null || dateGroupMenuState === void 0 ? void 0 : dateGroupMenuState.el) && (react_1.default.createElement(NonModalPopover_1.default, { open: true, anchorEl: dateGroupMenuState === null || dateGroupMenuState === void 0 ? void 0 : dateGroupMenuState.el, onClose: handleCloseDateGroupMenu, placement: "left-start" },
            react_1.default.createElement(react_1.default.Fragment, null, Object.values(TimeInterval_1.default).map(o => {
                const groupBy = dateGroupMenuState === null || dateGroupMenuState === void 0 ? void 0 : dateGroupMenuState.groupBy;
                const isSelected = !!groupBys.find(g => g.queryFieldKey === groupBy.queryFieldKey &&
                    g.timeInterval === o);
                return (react_1.default.createElement(MenuItem_1.default, { key: 'dateGrouper' + o, onClick: handleToggleDateGrouper(o), label: (0, TimeInterval_1.timeIntervalLabel)(o), icon: react_1.default.createElement(Switch_1.default, { tiny: true, onChange: handleToggleDateGrouper(o), checked: isSelected, color: lib_palette_1.default.secondary }) }));
            }))))));
}
exports.GroupersMenu = GroupersMenu;
exports.default = GroupersMenu;
